import { Box, Chip, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import onboardingTags from "src/onboarding-tags.json";
import { useSessionStorage } from "src/utils/useSessionStorage.js";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "src/utils/AuthContext.js";
import { useUpdateTags } from "src/services/index.js";

const PersonalizeTags = ({ onTagChange }) => {
  const theme = useTheme();
  const { user, refetchAuth } = useContext(AuthContext);
  // Initialize tags from either user profile or session storage
  const [sessionTags, setSessionTags] = useSessionStorage("userTags", []);
  const [selectedTags, setSelectedTags] = useState(user?.tags || sessionTags);
  const { mutateAsync: updateTags } = useUpdateTags();

  // Update selectedTags when user auth state changes
  useEffect(() => {
    if (user) {
      setSelectedTags(user.tags || []);
    } else {
      setSelectedTags(sessionTags);
    }
  }, [user, sessionTags]);

  useEffect(() => {
    return () => {
      if (user) {
        refetchAuth();
      }
    };
  }, []);

  const handleTagClick = async (tag) => {
    const newTags = selectedTags.includes(tag)
      ? selectedTags.filter((t) => t !== tag)
      : [...selectedTags, tag];

    const action = selectedTags.includes(tag) ? "remove" : "add";

    onTagChange(action, tag);

    if (user) {
      try {
        await updateTags({ tags: newTags });
        setSelectedTags(newTags);
      } catch (error) {
        refetchAuth();
      }
    } else {
      setSessionTags(newTags);
      setSelectedTags(newTags);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        width: "100%",
        maxWidth: "600px",
        mb: "100px",
      }}
    >
      {Object.entries(onboardingTags).map(([category, categoryTags]) => (
        <Box key={category}>
          <Typography
            variant="h2"
            sx={{
              mb: 2,
              textAlign: "left",
              width: "100%",
            }}
          >
            {category}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              width: "100%",
            }}
          >
            {categoryTags.map((tag) => (
              <Chip
                key={tag}
                label={tag}
                onClick={() => handleTagClick(tag)}
                color={selectedTags.includes(tag) ? "primary" : "default"}
                variant={selectedTags.includes(tag) ? "default" : "outlined"}
                sx={{
                  height: "32px",
                  borderRadius: "16px",
                }}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default PersonalizeTags;
